import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'clickSyncProcessLogManagementExperience.list'

const ClickSyncProcessLogManagementClickSyncProcessLogListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ClickSyncProcessLogManagementClickSyncProcessLogListSlice
